// extracted by mini-css-extract-plugin
module.exports = {"PasswordForgot":"PasswordForgot_PasswordForgot__sylOS"};